"use client"

import React from 'react'
import { Suspense } from 'react'
import { useEffect, useState } from "react"
import { SlideIn, Transition } from './ui/transitions';
import { TextReveal } from './ui/typography';
import { ArrowUpRight } from 'lucide-react';
import LoaderWrapper from './loader/loaderWrapper';
import { HeroCopy } from '@/app/copywritting';
import Spline from '@splinetool/react-spline';
import WavePlaneCanvas from './waveComponent/wavePlaneCanvas';

interface Props {
  containerRef?: React.RefObject<HTMLDivElement>;
  className?: string;
  height?: number;
}

const Hero = (props: Props) => {
  const { containerRef } = props;
  const [currentIndex, setCurrentIndex] = useState(0);
  const [scrollOpacity, setScrollOpacity] = useState(0.2);
  const [scrollColorChange, setScrollColorChange] = useState(false);
  const [scrollProgress, setScrollProgress] = useState(0);
  const [isMobile, setIsMobile] = useState(false);
  const [hideBusiness, setHideBusiness] = useState(false);
  var hideBusiness2 : Boolean = false;
  const [textFactor, setTextFactor] = useState(120);
  const [isLogo3DVisible, setLogo3DVisible] = useState(true)

  useEffect(() => {
    if (window.matchMedia(`(max-width: 768px)`).matches){
      setLogo3DVisible(false)
    } else {
      setLogo3DVisible(true)
    }
    const interval = setInterval(() => {
      setCurrentIndex(prevIndex => (prevIndex + 1) % HeroCopy.textList.length)
      hideBusiness2 = !hideBusiness2
    }, 1200)
    // if(currentIndex == 2){
    //     setHideBusiness(true)
    //   } else {
    //     setHideBusiness(false)
    //   }
    //   console.log(currentIndex,"HIDE")
    if (window.matchMedia(`(max-width: 768px)`).matches){
      setTextFactor(40)
    } else {
      setTextFactor(120)
    }
    
    
    const handleScroll = () => {
      const target = containerRef?.current || document.documentElement;

      // Calculate the scroll progress based on the target element's scroll position
      const { scrollTop, scrollHeight, clientHeight } = target;
      const totalHeight = scrollHeight - clientHeight;
      const progress = (scrollTop / totalHeight) * 100;

      if (progress >= 1.5) {
        setScrollColorChange(true)
      } else {
        setScrollColorChange(false)
      }
      
      const scrollPosition = window.scrollY;
      const maxScroll = 500;
      const opacity = Math.min(0.2 + (scrollPosition / maxScroll) * 0.8, 1);
      setScrollOpacity(opacity);
    }
    window.addEventListener("scroll", handleScroll)
    return () => {clearInterval(interval),window.removeEventListener("scroll", handleScroll)}
  }, [])

  return (
    <section className='h-150 md:h-screen overflow-hidden relative'>
        {/* <LoaderWrapper> */}
        <WavePlaneCanvas />
            <div className="h-[70%]relative flex flex-col place-items-center pt-10">
              <div className={`h-100 w-full ${isLogo3DVisible ? "":"hidden"}`}>
                <Suspense fallback={<div>Loading...</div>}>
                  <Spline scene="https://prod.spline.design/ArTuBeme9q-NKpe3/scene.splinecode" />
                </Suspense>
                <div className='relative fixed bg-[#f8f8ff] z-[499] h-10 w-50 -mt-15 -ml-50 left-[100%]'></div>
              </div>
              <div className={`flex flex-col place-items-center pb-4 ${isLogo3DVisible ? "-mt-30":"pt-35"}`}>
                <div className='flex flex- gap-x-[1rem]'>
                  <h2 className="text-2xl font-medium tracking-tighter">{HeroCopy.title}</h2>
                </div>
          <h2 className={`uppercase font-bold text-6xl md:text-7xl tracking-tighter transition-colors duration-500 ease-in-out ${hideBusiness2 ? "text-white" : "text-black"} `}>{HeroCopy.subtitle}</h2> 
                <div className='flex flex-row gap-x-[1rem] overflow-hidden h-10 md:h-20'>
                  <ul className="transition-transform duration-500 ease-out uppercase md:-mt-5"
                      style={{transform: `translateY(-${currentIndex * textFactor}px)`}}>
                        {HeroCopy.textList.map((text, index) => (
                          <li 
                            key={text}
                            className="text-3xl md:text-6xl font-bold h-10 md:h-30 flex items-center justify-center tracking-tighter text-center"
                          >
                            {text}
                          </li>
                        ))}
                  </ul>
                </div>
          <p className={`text-md md:text-xl text-center pt-10 md:pt-1 w-60 md:w-120 text-[#6d6e73] md:text-[#f8f8ff] leading-none transition-colors duration-500 ease-in-out ${scrollColorChange ? "md:text-black" : "md:text-white"}`}>{HeroCopy.mainText}</p>
              </div>
              <a href={HeroCopy.cta_link} target='_blank' className='font-bold bg-[#0b0d15] py-2 px-3 md:py-3 md:px-6 rounded-md hover:bg-[#892CDC] text-[#f8f8ff] cursor-pointer tracking-wide"'>
                {HeroCopy.cta_text}
              </a>
            </div>
            
        {/* </LoaderWrapper> */}
        
    </section>
    
  )
}

export default Hero